import type { ReviewEntryQuestion } from '../types/reviewEntryQuestion'

const THIRD_PARTY_AGENT = 'third-party'

export const isThirdPartyQuestion = (question: ReviewEntryQuestion): boolean => question.agent === THIRD_PARTY_AGENT

export const hasThirdPartyQuestion = (questions: ReviewEntryQuestion[]): boolean => questions.some(isThirdPartyQuestion)

export const excludeThirdPartyQuestions = (questions: ReviewEntryQuestion[]): ReviewEntryQuestion[] =>
  questions.filter((question) => !isThirdPartyQuestion(question))
